const MEGABYTE = 1024 * 1024;

export const UPLOAD_LIMITS = {
  photoBytes: 3 * MEGABYTE,
  photoCount: 10,
  videoBytes: 20 * MEGABYTE,
  videoDurationSeconds: 60,
  documentBytes: 5 * MEGABYTE,
  totalBytes: 70 * MEGABYTE,
};

export const getUploadFiles = (values) => {
  const files = [];
  const visit = (value) => {
    if (Array.isArray(value)) {
      value.forEach(visit);
    } else if (typeof File !== "undefined" && value instanceof File) {
      files.push(value);
    } else if (value && typeof value === "object" && value.file) {
      visit(value.file);
    }
  };

  visit(values);
  return [...new Set(files)];
};

export const getUploadValidationError = ({
  photoFiles = [],
  photoCount = getUploadFiles(photoFiles).length,
  videoFile,
  documentFile,
  otherFiles = [],
}) => {
  const photos = getUploadFiles(photoFiles);
  const video = getUploadFiles(videoFile)[0];
  const document = getUploadFiles(documentFile)[0];

  if (photos.length > 0 && photoCount > UPLOAD_LIMITS.photoCount) {
    return `You can upload up to ${UPLOAD_LIMITS.photoCount} profile photos.`;
  }
  if (photos.some((file) => file.size > UPLOAD_LIMITS.photoBytes)) {
    return "Each profile photo must be 3 MB or smaller.";
  }
  if (video?.size > UPLOAD_LIMITS.videoBytes) {
    return "The introduction video must be 20 MB or smaller.";
  }
  if (document?.size > UPLOAD_LIMITS.documentBytes) {
    return "Each document must be 5 MB or smaller.";
  }

  const totalBytes = getUploadFiles([
    photos,
    video,
    document,
    otherFiles,
  ]).reduce((total, file) => total + file.size, 0);
  if (totalBytes > UPLOAD_LIMITS.totalBytes) {
    return "Selected media must total 70 MB or less.";
  }

  return null;
};

export const getVideoDurationError = (file) =>
  new Promise((resolve) => {
    const video = document.createElement("video");
    const objectUrl = URL.createObjectURL(file);
    const cleanup = () => URL.revokeObjectURL(objectUrl);

    video.preload = "metadata";
    video.onloadedmetadata = () => {
      const duration = video.duration;
      cleanup();
      resolve(
        !Number.isFinite(duration)
          ? "The video duration could not be checked. Please choose another file."
          : duration > UPLOAD_LIMITS.videoDurationSeconds
            ? "The introduction video must be 60 seconds or shorter."
            : null,
      );
    };
    video.onerror = () => {
      cleanup();
      resolve(
        "The video duration could not be checked. Please choose another file.",
      );
    };
    video.src = objectUrl;
  });

export const validateUploadSelection = async (selection) => {
  const validationError = getUploadValidationError(selection);
  if (validationError) return validationError;

  const videoFile = getUploadFiles(selection.videoFile)[0];
  return videoFile ? getVideoDurationError(videoFile) : null;
};
